import { computed, ref } from 'vue';

export const PASSWORDS_DIFFER = "Passwords don't match";

// The rule sso-api applies wherever a password is set (XN-4839). Only sso-api
// can check a password against known breaches; its message shows on submit.
export const PASSWORD_HINT = 'At least 12 characters, with upper and lower case letters and a number.';

export const meetsPasswordRule = (password) => (password ?? '').length >= 12
  && /[a-z]/.test(password) && /[A-Z]/.test(password) && /\d/.test(password);

/**
 * Says so when the two password fields disagree, instead of leaving a grey
 * Create Account button to explain itself.
 *
 * Not on the first keystroke of the confirmation, which is always "wrong" while
 * it is being typed: once it is as long as the password, or once the person
 * leaves the field. From then on it follows every keystroke, so fixing it
 * clears it.
 *
 * @param {() => string} password
 * @param {() => string} confirmation
 */
export default function usePasswordMatch(password, confirmation) {
  const left = ref(false);

  const mismatch = computed(() => {
    const first = password() ?? '';
    const second = confirmation() ?? '';

    if (!first || !second || first === second) return '';

    return left.value || second.length >= first.length ? PASSWORDS_DIFFER : '';
  });

  /** For `@update:focused` on the confirmation field. */
  const onConfirmationFocus = (focused) => {
    if (!focused && confirmation()) left.value = true;
  };

  return { mismatch, onConfirmationFocus };
}
